<template>
	<div :class="[companyClass , canScroll]">
		<div class="page-table column mb-20" :class="{'flex':!isMobile, 'overflow':isMobile}">
			<div class="page-header">
				<h1 class="pageTitle">Transaction Rules</h1>
				<h4>transactions list </h4>
				<el-breadcrumb separator="/">
					<el-breadcrumb-item :to="{ path: '/' }"><i class="mdi mdi-home-outline"></i></el-breadcrumb-item>
					<el-breadcrumb-item>transactions</el-breadcrumb-item>
					<el-breadcrumb-item>transaction rules</el-breadcrumb-item>
				</el-breadcrumb>
			</div>

			<div class="mt-0">
				<div style="float: right;">
					<el-button v-show="showDelete && userPermissionsFilter.deletetransactionrule" type="danger" icon="el-icon-delete" 
						@click="deleteSelectedPrompt"></el-button>
					<el-button v-show="!showDelete && userPermissionsFilter.addtransactionrule"  type="primary" icon="el-icon-plus"
						@click="createTransactionRule"></el-button>
				</div>
			</div>

			<div class="toolbar-box flex">
				<div class="search-box box grow">
					<div><i class="mdi mdi-magnify"></i></div>
					<input v-model="search" placeholder="Search..."/>
				</div>
				<div class="pagination-box animated fadeInRight">
					<div class="select-box">
						<el-select v-model="paginationInfo.pageSize" placeholder="Rows per page" size="mini">
							<el-option value="10" label="10"></el-option>
							<el-option value="15" label="15"></el-option>
							<el-option value="20" label="20"></el-option>
							<el-option value="30" label="30"></el-option>
							<el-option value="50" label="50"></el-option>
							<el-option value="100" label="100"></el-option>
						</el-select>
					</div>
					<div class="label">/page</div>
				</div>
				<div class="csv-box animated fadeInRight">
					<button @click="downloadData">download csv ({{total}})</button>
				</div>
			</div>

			<resize-observer @notify="handleResize" />
			
			<div class="table-box card-base card-shadow--medium box grow" id="table-wrapper" v-loading="!asyncComponent">
				<div :style="{ 'width': width + 'px' }">
					<!-- v2-table -->
					<component :is="asyncComponent" ref="table"
						:data="list"
						:height="height"
						:border="false"
						:total="total"
						:lazy-load="false"
						:loading="loading"
						class="styled"
						:class="{'mobile':isMobile}"
						@page-change="handlePageChange"
						:pagination-info="paginationInfo"
						:default-sort="{prop:sortingProp, order:sortingOrder}"
						@sort-change="handleSortChange"
						@select-change="handleSelectChange"
						:show-summary="showSummary"
						:shown-pagination="shownPagination">
						<v2-table-column type="selection" width="45"></v2-table-column>
						<v2-table-column label="Country" prop="countryName" sortable width="150" 
						align="left" :fixed="isMobile?'':'left'"></v2-table-column>
						<v2-table-column label="Service Type" prop="serviceTypeName" sortable width="150" 
						align="left" :fixed="isMobile?'':'left'"></v2-table-column>

						<v2-table-column label="Partner" prop="serviceProviderName" width="150" align="left" sortable></v2-table-column>
						<v2-table-column label="From Amount" prop="fromAmountStr" width="150" align="left" sortable></v2-table-column>
						<v2-table-column label="To Amount" prop="toAmountStr" width="150" align="left" sortable></v2-table-column>
						<v2-table-column label="Date" prop="createdOnStr" sortable width="150" 
						align="center" :fixed="isMobile?'':'right'"></v2-table-column>
						

						<v2-table-column label="Action" width="70" :fixed="isMobile?'':'right'">
							<template slot-scope="row">
								<div class="custom-action-row">
									<el-button @click="print(row)"><i class="mdi mdi-eye"></i></el-button>
								</div> 
							</template>
						</v2-table-column>
					</component><!-- v2-table -->

				</div>
			</div>
		</div>
	</div>
</template>

<script>
import moment from 'moment-timezone'
import PermissionsMixins from '@/mixins/PermissionsMixins'
import router from '@/router/' 
import { bus } from '@/main'

export default {
	name: 'TransactionRules',
	data () {
      	return {
		}
	},
    methods: {
		downloadData() {
			this.getTransactionRules(this.currentPage, this.paginationInfo.pageSize)
			.then(result=> {
				if(result.items)
					this.downloadCSV(result.items.map(p=> {
						var c = {
							Country: p.countryName,
							Service_Type: p.serviceTypeName,
							Service_Provider: p.serviceProviderName,
							From_Amount: p.fromAmountStr,
							To_Amount: p.toAmountStr,
							CreatedOn: p.createdOnStr
						};

						return c;
					}));
			})
			.catch(err=> this.errorMessage('Error downloading data.'));
		},
		handlePageChange(page) {
			this.currentPage = page;
			this.refreshTransactionRules();
		},
		print(row) {
			router.push(`/updatetransactionrule/${row.id}`);
		},
        createTransactionRule() {
            router.push('/addtransactionrule');
        },
        deleteSelectedRules() {
			var ids = this.selectedItems.map(p=> p.id);
			this.deleteTransactionRules(ids)
			.then(result=> {
				if(result){
					this.refreshTransactionRules();
				}
			});
		},
		refreshTransactionRules() {
			this.getTransactionRules(this.currentPage, this.paginationInfo.pageSize)
			.then(result=> this.tableRefreshed(result))
			.catch(err=> this.tableRefreshed(this.defaultListResult));
        }
	},
	created() {
		this.deleteEvent = 'deleteSelectedRules';
		this.refreshListEvent = 'refreshTransactionRules';
		this.$on(this.refreshListEvent, this.refreshTransactionRules);
		this.$on(this.deleteEvent, this.deleteSelectedRules);
	},
	mounted() {
		this.refreshTransactionRules();
    },
    mixins: [PermissionsMixins]
}
</script>

<style lang="scss" scoped>

.page-table {
	&.overflow {
		overflow: auto;
	}
	
	.table-box {
		overflow: hidden;
	}
}
</style>
<style lang="scss">
@import '../../assets/scss/_variables';
.page-table {
	.custom-action-row {
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;

		.el-button {
			padding: 1px 5px;
		}
	}

	.toolbar-box {
		margin-top: 20px;

		.search-box {
			& > div {
				width: 20px;
				display: inline-block;
			}

			margin-bottom: 10px;

			i {
				display: inline-block;
				width: 22px;
			}

			input {
				outline: none;
				background: transparent;
				border: none;
				font-size: 15px;
				position: relative;
				padding: 0;
				margin-left: -20px;
				display: inline-block;
				padding-left: 20px;
				box-sizing: border-box;
				top: -1px;
				width: 100%;
				color: $text-color;
			}

			.icons-tot {
				margin-right: 20px;
			}
		}

		.pagination-box {
			width: 120px;
			margin: 0 15px;

			.select-box {
				width: 70px;
				display: inline-block;
			}

			.label {
				width: 50px;
				display: inline-block;
			}

			.el-input__inner {
				height: 22px;
				border: none;
				background: transparent;
				font-size: 16px;
				text-align: right;
				font-family: inherit;
				padding-right: 20px;
				color: $text-color;
			}

			.el-input__suffix {
				right: -3px;

				.el-select__caret {
					color: transparentize($text-color, 0.7);
				}
			}
		}

		a, button {
			padding: 0;
			margin: 0 15px;
			background: transparent;
			border: none;
			outline: none;
			font-family: inherit;
			font-size: inherit;
			cursor: pointer;

			border-bottom: 1px solid;
			text-decoration: none;
			color: $text-color;
			&:hover {
				opacity: .6;
			}
		}

		a {
			margin-right: 0;
		}
	}

	.sel-string {
		.sel {
			background: transparentize($text-color, 0.8);
			border-radius: 5px;
			text-transform: uppercase;
		}
	}
}

@media (max-width: 768px) {
	.page-table {
		.toolbar-box {
			display: block;
			overflow: hidden;
			font-size: 80%;
		
			& > * {
				display: inline-block;
				min-width: 120px;
				height: 22px;
				background: rgba(0, 0, 0, 0.04);
				padding: 4px;
				margin: 3px !important;
			}
		}
	}
}
</style>

